// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"658":"0ed52e82","855":"0ed52e82"}[chunkId] + ".chunk.css";
};